import { useState, useEffect } from 'react';

const useFacebookSDK = (appId, language = "vi") => {
  const [loading, setLoading] = useState(true);
  const [available, setAvailable] = useState(true);
  useEffect(() => {
    if (typeof window === "undefined")
      return;
    if (!!(window == null ? void 0 : window.fbAsyncInit)) {
      setAvailable(true);
      setLoading(false);
      return;
    }
    initializeFacebook(appId, language).catch(() => setAvailable(false)).then(() => {
    }).finally(() => setLoading(false));
  }, [appId, language]);
  const xfbmlParse = () => {
    if (typeof window === "undefined")
      return;
    if (window == null ? void 0 : window.FB) {
      window.FB.XFBML.parse();
    }
  };
  const fb = typeof window !== "undefined" ? window == null ? void 0 : window.FB : void 0;
  return { loading, available, fb, xfbmlParse };
};
const initializeFacebook = async (appId, language) => {
  return new Promise((resolve, reject) => {
    window.fbAsyncInit = function() {
      try {
        FB.init({
          appId,
          status: true,
          cookie: true,
          xfbml: true,
          version: "v16.0",
          autoLogAppEvents: true
        });
        resolve(true);
      } catch (e) {
        reject(false);
      }
    };
    (function(d, s, id) {
      var _a;
      if (d.getElementById(id)) {
        resolve(true);
      }
      const fjs = d.getElementsByTagName(s)[0];
      const js = d.createElement(s);
      js.id = id;
      js.async = true;
      js.src = `https://connect.facebook.net/${language === "en" ? "en_US" : "vi_VN"}/sdk.js`;
      js.defer = true;
      (_a = fjs.parentNode) == null ? void 0 : _a.insertBefore(js, fjs);
    })(document, "script", "facebook-jssdk");
  });
};

export { useFacebookSDK };
